'use client';

import Link from '@eliadmin/core/src/components/link';

import type { Blog } from '@eliadmin/core/src/api/blogs/blogs-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Button } from '../ui/button';
import { Heading } from '../ui/heading';
import { Carousel } from '@eliadmin/core/src/components/ui/carousel';
import { BlogCard } from '@eliadmin/core/src/components/blog/blog-card';
import { CarouselProgress } from '../ui/carousel-progress';
import { useCarouselContext } from '@eliadmin/core/src/components/ui/carousel-context';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function Blogs({ blogs, title }: { blogs: Blog[]; title: string }) {
  const { t } = useTranslations();
  const options = {
    align: 'start' as const,
  };

  const carouselContext = useCarouselContext();

  if (!carouselContext) {
    throw new Error('Hero must be used within a CarouselProvider');
  }

  const { selectedIndex } = carouselContext;

  return (
    <section
      className={cn(
        'custom-section',
        'gap-6 bg-[#FAFAFA] pr-0 sm:gap-8 md:gap-10 lg:gap-12 xl:pr-5',
        'ea-section__xxl-y',
      )}
    >
      <Heading
        tag="h2"
        title={title}
        className="w-full max-w-[670px] text-balance pr-5 text-center xl:pr-0"
      />
      <div className={cn('custom-container')}>
        <Carousel
          options={options}
          className={{
            container: 'w-full gap-4 sm:gap-5 lg:gap-6',
            main: 'w-full',
            wrapper: 'w-full',
            slide: 'w-full max-w-[300px] sm:max-w-[330px] md:max-w-[480px] lg:max-w-[652px]',
          }}
          slides={blogs.map(blog => (
            <BlogCard blog={blog} key={blog.slug} />
          ))}
        />
      </div>
      <div className="flex w-full pr-5 md:hidden">
        <CarouselProgress selectedIndex={selectedIndex} totalSlides={blogs.length} />
      </div>
      <div className="flex w-full items-center justify-center pr-5 xl:pr-0">
        <Button asChild className="w-full sm:w-fit">
          <Link href={'/blog'}>
            {t('text2000')}
          </Link>
        </Button>
      </div>
    </section>
  );
}
